interface IEnv {
    API_URL: string | undefined;
    VITE_API_PREVIEW_LOGS_URL: string | undefined;
    APP_URL: string | undefined;
    SOCKET_URL: string | undefined;
    ENV_MODE: "dev" | "test" | "uat" | "prod" | string | undefined;
    ENABLE_REDUX_LOGS: boolean;
    ENABLE_HTTP_LOGS: boolean;
    MIXPANEL_TOKEN: string | undefined;
    GOOGLE_CLIENT_ID: string ;
    VITE_API_URL_LOGS: string ;
    VITE_ADMIN_API: string ;
    ELEVENLABS_REQUIREMENT_AGENT_ID: string | undefined;
    ELEVENLABS_APP_BUILDER_AGENT_ID: string | undefined;
    RAZORPAY_KEY: string | undefined;
}

const ENV: IEnv = {
    API_URL: import.meta.env.VITE_API_URL,
    VITE_API_PREVIEW_LOGS_URL: import.meta.env.VITE_API_PREVIEW_LOGS_URL,
    VITE_ADMIN_API: import.meta.env.VITE_ADMIN_API,
    VITE_API_URL_LOGS: import.meta.env.VITE_API_URL_LOGS,
    APP_URL: import.meta.env.VITE_APP_URL,
    SOCKET_URL: import.meta.env.VITE_APP_SOCKET_URL,
    ENV_MODE: import.meta.env.VITE_ENV,
    GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
    MIXPANEL_TOKEN: import.meta.env.VITE_MIXPANEL_TOKEN,
    ENABLE_REDUX_LOGS: (import.meta.env.VITE_ENABLE_REDUX_LOGS) === 'true',
    ENABLE_HTTP_LOGS: (import.meta.env.VITE_ENABLE_HTTP_LOGS) === 'true',
    ELEVENLABS_REQUIREMENT_AGENT_ID: import.meta.env.VITE_ELEVENLABS_REQUIREMENT_AGENT_ID,
    ELEVENLABS_APP_BUILDER_AGENT_ID: import.meta.env.VITE_ELEVENLABS_APP_BUILDER_AGENT_ID,
    RAZORPAY_KEY: import.meta.env.VITE_RAZORPAY_KEY,
}


export default ENV;
